<template>
  <div>
    <ExecutableActionItem
      v-for="actionItem in actionsList"
      :action-item="actionItem"
      :output-format="outputFormat"
      :key="actionItem.action + actionItem.fragmentId"
      @verify="toggleVerify"
    />
  </div>
</template>

<script>
import ExecutableActionItem from './ExecutableActionItem';

export default {
  components: { ExecutableActionItem },
  props: {
    executablePlanItems: {
      type: Array,
      default: () => [],
    },
    outputFormat: {
      type: String,
      default: 'side-by-side',
    },
  },
  emits: ['verify-change'],
  data() {
    return {
      verifiedActions: [],
    };
  },
  computed: {
    verifiedExecutablePlan() {
      const executablePlanLength = this.executablePlanItems?.length;
      return (
        executablePlanLength > 0 &&
        executablePlanLength === this.verifiedActions.length
      );
    },
    actionsList() {
      return this.executablePlanItems.map((actionItem) => ({
        ...actionItem,
        verified: this.verifiedActions.includes(this.getActionId(actionItem)),
      }));
    },
  },
  watch: {
    verifiedExecutablePlan(newVal) {
      this.$emit('verify-change', newVal);
    },
  },
  methods: {
    getActionId(actionItem) {
      return `${actionItem.action}_${actionItem.fragmentId}`;
    },
    toggleVerify({ actionItem, verified }) {
      const id = this.getActionId(actionItem);
      if (verified) {
        this.verifiedActions.push(id);
        return;
      }
      const index = this.verifiedActions.indexOf(id);
      if (index > -1) {
        this.verifiedActions.splice(index, 1);
      }
    },
    verifyAll(verify) {
      if (verify) {
        this.verifiedActions = [];
        this.executablePlanItems.map((actionItem) => ({
          ...actionItem,
          verified: false,
        }));
      } else {
        const allIDs = this.executablePlanItems.map(
          (actionItem) => `${actionItem.action}_${actionItem.fragmentId}`
        );
        this.executablePlanItems.map((actionItem) => ({
          ...actionItem,
          verified: true,
        }));
        this.verifiedActions = allIDs;
      }
    },
  },
};
</script>
